import L from "leaflet";
import { useState } from "react";
import { Marker, Tooltip, useMap, useMapEvents } from "react-leaflet";

export const STAFF_GROUPS = {
  policia: { label: "Policía Local", svg: `<path d="M12 1.5 L21 5 V11.5 C21 17 17 21 12 22.5 C7 21 3 17 3 11.5 V5 Z" fill="#1d4ed8" stroke="#fff" stroke-width="1.5"/><path d="M12 6.5 L13.6 10 L17.3 10.3 L14.5 12.7 L15.4 16.4 L12 14.4 L8.6 16.4 L9.5 12.7 L6.7 10.3 L10.4 10 Z" fill="#fde047"/>` },
  pc: { label: "Protección Civil", svg: `<circle cx="12" cy="12" r="11" fill="#f97316" stroke="#fff" stroke-width="1.5"/><path d="M12 5 L19 18 H5 Z" fill="#1e3a8a"/>` },
  voluntarios: { label: "Voluntarios / auxiliares", svg: `<circle cx="12" cy="12" r="11" fill="#16a34a" stroke="#fff" stroke-width="1.5"/><circle cx="12" cy="8" r="3" fill="#fff"/><path d="M6 19 C6 14.5 8.5 12.5 12 12.5 C15.5 12.5 18 14.5 18 19 Z" fill="#fff"/>` },
};

export const staffSvg = (g, size = 18) => `<svg width="${size}" height="${size}" viewBox="0 0 24 24">${STAFF_GROUPS[g].svg}</svg>`;

export const StaffMini = ({ group, size = 14 }) => (
  <span className="inline-flex shrink-0" dangerouslySetInnerHTML={{ __html: staffSvg(group, size) }} />
);

const staffIcon = (p, sel) => {
  const chips = Object.keys(STAFF_GROUPS).filter((g) => p.groups[g]).map((g) =>
    `<span style="display:inline-flex;align-items:center;gap:2px;background:#0f172aee;border:1px solid #ffffff55;border-radius:10px;padding:1px 5px 1px 2px;color:#fff;font:700 10px/16px sans-serif">${staffSvg(g, 16)}${p.groups[g]}</span>`).join("");
  return L.divIcon({ className: "", html: `<div style="display:flex;gap:2px;white-space:nowrap;filter:drop-shadow(0 1px 2px #000);${sel ? "outline:2px solid #38bdf8;outline-offset:2px;border-radius:12px;" : ""}${p.moved ? "opacity:.95" : ""}">${chips}</div>`, iconSize: [40, 18], iconAnchor: [-10, 26] });
};

export const StaffMarkers = ({ points = [], minZoom = 15, onSelect, selectedKey, onMove }) => {
  const map = useMap();
  const [zoom, setZoom] = useState(map.getZoom());
  useMapEvents({ zoomend: () => setZoom(map.getZoom()) });
  return zoom < minZoom && !selectedKey ? null : <StaffList points={points} onSelect={onSelect} selectedKey={selectedKey} onMove={onMove} />;
};

const StaffList = ({ points, onSelect, selectedKey, onMove }) => points.map((p, i) => (
  <Marker key={`staff-${p.key || i}-${p.loc[0]}-${p.loc[1]}`} position={p.loc} icon={staffIcon(p, p.key === selectedKey)} interactive={!!p.tasks?.length}
    draggable={!!onMove && p.key === selectedKey} zIndexOffset={p.key === selectedKey ? 900 : 0}
    eventHandlers={{
      click: (e) => { e.originalEvent && L.DomEvent.stopPropagation(e); onSelect && onSelect(p.key); },
      dragend: (e) => { const ll = e.target.getLatLng(); onMove(p.key, [+ll.lat.toFixed(6), +ll.lng.toFixed(6)]); },
    }}>
    {p.tasks?.length > 0 && (
      <Tooltip direction="top" offset={[30, -24]}>
        <div className="text-xs max-w-[260px] whitespace-normal">
          {Object.keys(STAFF_GROUPS).filter((g) => p.groups[g]).map((g) => <div key={g}><b>{STAFF_GROUPS[g].label}:</b> {p.groups[g]} · {(p.units?.[g] || []).join(", ")}</div>)}
          <div className="text-slate-500 mt-1">{p.tasks.map((t, j) => <div key={j}>· {t}</div>)}</div>
        </div>
      </Tooltip>
    )}
  </Marker>
));
